import { TVerifyTokenBody } from '../utils/types/agrocraftArtisan';
import { updateToken } from '../reduxActions/tokenSlice';
import { Token } from '../utils/types';
import { emptySplitApi } from './base/emptySplitApi';
import { encrypted } from '../utils/utility';

export const authUserService =
  emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
      verifyToken: builder.query<Token, TVerifyTokenBody>({
        query: (data) => ({
          url: 'authenticate',
          method: 'POST',
          data,
        }),
        async onQueryStarted(
          args,
          { dispatch, queryFulfilled }
        ) {
          queryFulfilled
            .then(({ data }: { data: Token }) => {
              const encryptedToken = encrypted.encrypt(JSON.stringify(data));

              localStorage.setItem('authToken', encryptedToken);
              dispatch(updateToken(data));
            })
            .catch((error) => error);
        },
      }),

      getAuthInfo: builder.query<{ login_url: string }, void>({
        query: () => ({
          url: 'auth/azure/auth-info',
          method: 'GET',
          encrypt: true,
          decrypt: true,
        }),
      }),

      authenticateWithCode: builder.mutation<
        { token: string; app_user?: Record<string, unknown>; flag?: boolean; refreshToken?: string },
        { code: string }
      >({
        query: (data) => ({
          url: 'auth/azure/authenticate',
          method: 'POST',
          data: { code: data.code },
          encrypt: true,
          decrypt: true,
        }),
        async onQueryStarted(
          args,
          { dispatch, queryFulfilled }
        ) {
          queryFulfilled
            .then(({ data }) => {
              if (!data || !data.token) {
                console.error('Invalid response data:', data);
                return;
              }
          
              const tokenData: Token = {
                token: data.token,
                refreshToken: data.refreshToken || '',
              };
              const encryptedToken = encrypted.encrypt(JSON.stringify(tokenData));

              localStorage.setItem('authToken', encryptedToken);
              dispatch(updateToken(tokenData));

              // Store user details
              if (data.app_user) {
                const encryptedLoginDetails = encrypted.encrypt(
                  JSON.stringify(data.app_user)
                );
                localStorage.setItem('LoggedInDetails', encryptedLoginDetails);
              }
              
              localStorage.setItem('isLogin', 'true');
              localStorage.setItem("isPolicy", JSON.stringify(data.flag));
            })
            .catch((error) => {
              console.error('Authentication error:', error);
            });
        },
      }),

      logout: builder.mutation<void, void>({
        query: () => ({
          url: 'app-users/logout',
          method: 'GET',
        }),
        async onQueryStarted() {
          try {
            localStorage.removeItem('token');
          } catch (error) {
            console.error('Logout cleanup failed', error);
          }
        },
      }),
    }),
  });

export const {
  useLazyVerifyTokenQuery,
  useLogoutMutation,
  useLazyGetAuthInfoQuery,
  useAuthenticateWithCodeMutation,
} = authUserService;